<template>
    <div>
      <table class="custom-table responsive-table border-collapse">
        <thead class="font-normal">
          <tr class="shadow-table rounded-lg opacity-50">
            <th>TRANSACTION TYPE</th>
            <th>DEBTORS</th>
            <th>TRANSACTION DATE</th>
            <th>TRANSACTION ID</th>
            <th>TRANSACTION AMOUNT</th>
            <th>RECEIPTS TO DATE</th>
            <th>OUTSTANDING AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="rounded-lg bg-white"
            v-for="i in [1, 2, 3, 4, 5, 6, 7]"
            :key="i"
          >
            <td>Credit Note</td>
            <td>Dangote Cement</td>
            <td>12/11/2020</td>
            <td>TRX-123</td>
            <td>N132,000</td>
            <td>N132,000</td>
            <td>N132,000</td>
          </tr>
        </tbody>
      </table>
  
      <!-- <EmptyContent v-if="!bookings.length" /> -->
    </div>
  </template>
  
  <script>
  //   import EmptyContent from "../UI/EmptyContent.vue";
  
  export default {
    props: ["bookings"],
    components: {},
    data() {
      return {
        showFilterModal: false,
        collectPaymentModal: false,
        selectedRowId: -1,
        shareLinkModal: false,
        totalCost: 0,
        transactionId: null,
        shippingId: "",
        paylink: "",
        email: "",
        payAmount: "",
      };
    },
    computed: {
      paymentParams() {
        return {
          paylink: this.paylink,
          email: this.email,
          payAmount: this.payAmount,
        };
      },
    },
    methods: {
      collectPaymentModalFunc(val) {
        this.totalCost = val?.transaction?.totalValue;
        this.transactionId = val?.transaction?.id;
        this.shippingId = val?.id;
        this.collectPaymentModal = true;
      },
      transactionRoute(val) {
        if (!val) return;
        localStorage.setItem("billing_reciept", "recievable");
      },
      sharelinkModalFunc(val) {
        this.payAmount = val?.transaction?.totalValue;
        this.email = val?.transaction?.id;
        this.paylink = val?.id;
        this.shareLinkModal = true;
      },
      statusBg(val) {
        let bg = "";
        switch (val) {
          case "pending":
            bg = "text-red-500";
            break;
          case "not paid":
            bg = "text-red-500";
            break;
          case "draft":
            bg = "text-red-500";
            break;
          case "paid":
            bg = "text-teal-500";
            break;
          case "estimate":
            bg = "text-primary-yellow";
            break;
  
          default:
            bg = "text-teal-500";
            break;
        }
        return bg;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .actions {
    @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
    min-width: 200px;
  }
  .actions div {
    @apply flex w-full py-2 px-2 items-center;
  }
  .icon {
    width: auto;
    padding-right: 5px;
  }
  th {
    font-weight: 300;
  }
  </style>
  